/* import __COLOCATED_TEMPLATE__ from './sms-restricted-countries-banner.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const SmsRestrictedCountriesBanner = templateOnlyComponent<Signature>();
export default SmsRestrictedCountriesBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::SmsRestrictedCountriesBanner': typeof SmsRestrictedCountriesBanner;
    'inbox2/sms-restricted-countries-banner': typeof SmsRestrictedCountriesBanner;
  }
}
